exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-document-form div.custom-control[data-v-2ceef884]{z-index:unset}.save-document-form div.custom-control .share-document-info div.share-document-box[data-v-2ceef884]{z-index:1}", ""]);

// exports
